module.exports = __webpack_public_path__ + "images/emoji/crocodile.83c20bdf33aa1f2a68b4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/crocodile.png
// module id = EKnj
// module chunks = 24